import event from 'wolfy87-eventemitter'
import { observable, action, autorun, configure, runInAction, when, reaction } from 'mobx'

export default class ToolBarStore{
    @observable currentTool = null
    @action
    changeTool(val) {
        this.currentTool = val
    }
    
    getCurrentTool(){
        return this.currentTool
    }
}
